import React from "react";
import { Switch, Box, styled } from "@mui/material";
import type { SwitchProps } from "@mui/material/Switch";
import StriimAI from "src/generic/icon/customIcons/striim-ai.svg";

const StriimAIIcon = StriimAI as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

const THUMB_MARGIN = 1;
const THUMB_TRANSLATE_OFF = 4;
const THUMB_TRANSLATE_ON = 22; // right-aligns thumb: margin(1) + 22 + thumb(26) + margin(1) = 50 = switch(56) - padding(6)
const THUMB_WIDTH = 26;
const ICON_SIZE = 14;

// Pixel position of the icon's left edge, centered over the thumb
const iconLeft = (translateX: number) =>
    `${THUMB_MARGIN + translateX + THUMB_WIDTH / 2 - ICON_SIZE / 2}px`;

const StyledSwitch = styled(Switch)(() => ({
    width: 56,
    height: 30,
    padding: 6,
    pointerEvents: "none",
    "& .MuiSwitch-switchBase": {
        margin: THUMB_MARGIN,
        padding: 0,
        transform: `translateX(${THUMB_TRANSLATE_OFF}px)`,
        "&.Mui-checked": {
            color: "#fff",
            transform: `translateX(${THUMB_TRANSLATE_ON}px)`,
            "& .MuiSwitch-thumb": {
                backgroundColor: "#7C3AED"
            },
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: "#DDD6FE"
            }
        }
    },
    "& .MuiSwitch-thumb": {
        backgroundColor: "#1e1b4b",
        width: THUMB_WIDTH,
        height: 26
    },
    "& .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#c7c9d9",
        borderRadius: 15
    }
}));

const AIModeSwitch: React.FC<SwitchProps> = ({ checked, ...props }) => (
    <Box sx={{ position: "relative", display: "inline-block", pointerEvents: "none" }}>
        <StyledSwitch checked={checked} {...props} />
        <Box
            sx={{
                position: "absolute",
                left: iconLeft(checked ? THUMB_TRANSLATE_ON : THUMB_TRANSLATE_OFF),
                top: "50%",
                transform: "translateY(-50%)",
                width: `${ICON_SIZE}px`,
                height: `${ICON_SIZE}px`,
                pointerEvents: "none",
                transition: "left 150ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& path": {
                    fill: checked ? "#ffffff" : "#9e9faf",
                    stroke: checked ? "#ffffff" : "#9e9faf"
                }
            }}
        >
            <StriimAIIcon width={ICON_SIZE} height={ICON_SIZE} />
        </Box>
    </Box>
);

export default AIModeSwitch;
